import { useEffect } from 'react';
import PropTypes from 'prop-types';

const WithReducedSiteFurniture = (props) => {
    useEffect(() => {
        const showSidebar = props.setSidebar && !props.sidebarDisabled;
        // display reduced site furniture
        // if showSidebar equals true display reduced site furniture and sidebar layout.
        window?.SF?.toggleReduced?.({ force: true, sidebar: showSidebar });
        showSidebar && props?.setSidebar(true);

        return () => {
            // display full site furniture
            window?.SF?.toggleReduced?.({ force: false });
            showSidebar && props?.setSidebar(false);
        };
    }, []);

    return props.children;
};

WithReducedSiteFurniture.propTypes = {
    children: PropTypes.any,
    setSidebar: PropTypes.func,
    sidebarEnabled: PropTypes.bool,
};

export default WithReducedSiteFurniture;
